/* =======================================================
   Islands of Loom — Handkerchief PDP JavaScript
   File: assets/hanky.js
   Loaded by: sections/hanky-main.liquid (deferred)

   Handles:
   - Pack selection (buttons + image pill + swipe) kept in sync
   - Swapping the image / price / labels for the chosen pack
   - Writing the chosen variant id to the hidden inputs (also used by GoKwik buy now)
   - Add to cart + cart drawer refresh (same approach as pdp-test.js)
   - Toast
   ======================================================= */
(function () {
  'use strict';

  var root = document.getElementById('hk-root');
  if (!root) return;

  var packBtns   = Array.prototype.slice.call(root.querySelectorAll('.hk-pack'));
  var toggleBtns = Array.prototype.slice.call(root.querySelectorAll('.hk-toggle__btn'));
  var packSlides   = Array.prototype.slice.call(root.querySelectorAll('.hk-slide[data-variant-id]'));
  var sharedSlides = Array.prototype.slice.call(root.querySelectorAll('.hk-slide--shared'));
  var dots         = Array.prototype.slice.call(root.querySelectorAll('.hk-dot'));
  var imgIndex = 0; // 0.. = shared images (flat lay first); last = the pack's own image
  var addBtn     = document.getElementById('hk-add-btn');
  var buyBtn     = document.getElementById('pdp-buy-btns');
  var priceEl    = document.getElementById('hk-price');
  var compareEl  = document.getElementById('hk-compare');
  var pickedEl   = document.getElementById('hk-picked');
  var subTitleEl = document.getElementById('hk-pricesub-title');
  var variantInput = document.getElementById('pdp-variant-id');
  var nativeInput  = document.getElementById('pdp-native-variant-id');

  var current = null; // currently selected pack button

  function findPack(variantId) {
    for (var i = 0; i < packBtns.length; i++) {
      if (packBtns[i].dataset.variantId === String(variantId)) return packBtns[i];
    }
    return null;
  }

  function selectPack(variantId, opts) {
    var btn = findPack(variantId);
    if (!btn || btn.disabled) return;
    current = btn;

    packBtns.forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    toggleBtns.forEach(function (b) {
      var on = b.dataset.variantId === btn.dataset.variantId;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    // Flat lay (shared image) is always the first image, whichever pack is chosen.
    imgIndex = 0;
    renderSlides();

    if (priceEl)   priceEl.textContent = btn.dataset.price || '';
    if (compareEl) {
      if (btn.dataset.compare) { compareEl.textContent = btn.dataset.compare; compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }
    if (pickedEl)   pickedEl.textContent = ' · ' + btn.dataset.title;
    if (subTitleEl) subTitleEl.textContent = btn.dataset.title;
    if (variantInput) variantInput.value = btn.dataset.variantId;
    if (nativeInput)  nativeInput.value  = btn.dataset.variantId;

    if (addBtn && !addBtn.classList.contains('is-added')) setCtaLabel();

    // Keep the URL shareable (?variant=ID) without reloading
    if (!opts || !opts.silent) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', btn.dataset.variantId);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
  }

  function renderSlides() {
    // Order: shared image(s) first (flat lay), then the selected pack's own image.
    var vid = current ? current.dataset.variantId : null;
    var packIdx = sharedSlides.length;
    sharedSlides.forEach(function (s, i) {
      s.classList.toggle('is-active', imgIndex === i);
      s.style.transform = 'translateX(' + ((i - imgIndex) * 100) + '%)';
    });
    packSlides.forEach(function (s) {
      var mine = s.dataset.variantId === vid;
      s.classList.toggle('is-current', mine);
      s.classList.toggle('is-active', mine && imgIndex === packIdx);
      s.style.transform = mine ? 'translateX(' + ((packIdx - imgIndex) * 100) + '%)' : '';
    });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === imgIndex); });
  }

  function goImage(i) {
    var total = sharedSlides.length + 1;
    imgIndex = (i + total) % total;
    renderSlides();
  }

  var prevBtn = document.getElementById('hk-prev');
  var nextBtn = document.getElementById('hk-next');
  if (prevBtn) prevBtn.addEventListener('click', function () { goImage(imgIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goImage(imgIndex + 1); });
  dots.forEach(function (d) {
    d.addEventListener('click', function () { goImage(parseInt(d.dataset.i, 10) || 0); });
  });

  function setCtaLabel() {
    if (!addBtn || !current) return;
    var ok = current.dataset.available === 'true';
    addBtn.disabled = !ok;
    if (buyBtn) buyBtn.disabled = !ok;
    addBtn.textContent = ok ? ('Add to cart · ' + current.dataset.title) : 'Sold out';
  }

  /* ---------- Bind pack buttons / pill ---------- */
  packBtns.forEach(function (b) {
    b.addEventListener('click', function () { selectPack(b.dataset.variantId); });
  });
  toggleBtns.forEach(function (b) {
    b.addEventListener('click', function () { selectPack(b.dataset.variantId); });
  });

  /* ---------- Swipe / drag on the image (touch, mouse and pen) ---------- */
  var media = document.getElementById('hk-media');
  if (media) {
    var sx = 0, sy = 0, down = false;
    media.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      sx = e.clientX; sy = e.clientY; down = true;
    });
    function endDrag(e) {
      if (!down) return;
      down = false;
      if (!sharedSlides.length) return;
      var dx = sx - e.clientX;
      var dy = Math.abs(sy - e.clientY);
      if (Math.abs(dx) > 40 && Math.abs(dx) > dy) goImage(imgIndex + (dx > 0 ? 1 : -1));
    }
    media.addEventListener('pointerup', endDrag);
    media.addEventListener('pointercancel', function () { down = false; });
    media.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // trackpad two-finger horizontal swipe
    var wheelLock = false;
    media.addEventListener('wheel', function (e) {
      if (!sharedSlides.length || Math.abs(e.deltaX) < 30 || Math.abs(e.deltaX) < Math.abs(e.deltaY) || wheelLock) return;
      e.preventDefault();
      wheelLock = true;
      goImage(imgIndex + (e.deltaX > 0 ? 1 : -1));
      setTimeout(function () { wheelLock = false; }, 500);
    }, { passive: false });
  }

  /* ---------- Toast ---------- */
  function ping(msg) {
    var t = document.getElementById('hk-toast');
    if (!t) return;
    t.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9DB3A0" stroke-width="2" stroke-linecap="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg> ' + msg;
    t.classList.add('show');
    clearTimeout(window.__hkToast);
    window.__hkToast = setTimeout(function () { t.classList.remove('show'); }, 2800);
  }

  /* ---------- Cart count + drawer (same as pdp-test.js) ---------- */
  var BADGE_SELECTORS = [
    '[data-cart-count]', '.cart-count', '#cart-count', '.header__cart-count',
    '.cart-icon-bubble .visually-hidden', '[data-cart-item-count]', '.cart-badge'
  ];

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        BADGE_SELECTORS.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', count);
            el.textContent = count > 0 ? count : '';
            if (count > 0) {
              el.classList.add('show');
              el.removeAttribute('hidden');
              el.setAttribute('aria-hidden', 'false');
            }
          });
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  function drawerIsOpen() {
    var d = document.getElementById('shtCartDrawer');
    return !!(d && d.classList.contains('active'));
  }

  function openDrawer() {
    if (drawerIsOpen()) return; // never toggle an already-open drawer shut
    var trigger = document.querySelector('.js-header-cart-status-btn');
    if (trigger) trigger.click();
  }

  function closeDrawer() {
    var d = document.getElementById('shtCartDrawer');
    if (!d || !d.classList.contains('active')) return;
    var btn = d.querySelector('[class*="close"]');
    if (btn) btn.click();
  }

  /* Side cart closes if the visitor scrolls the page (instead of hanging around
     or disappearing). Scrolling inside the cart panel itself is left alone. */
  (function () {
    var openedAt = 0;
    var wasOpen = false;
    window.addEventListener('scroll', function () {
      var open = drawerIsOpen();
      if (open && !wasOpen) openedAt = window.pageYOffset;
      wasOpen = open;
      if (open && Math.abs(window.pageYOffset - openedAt) > 80) closeDrawer();
    }, { passive: true });
    function onOutsideScroll(e) {
      if (!drawerIsOpen()) return;
      if (e.target && e.target.closest && e.target.closest('#cartDrawer')) return;
      closeDrawer();
    }
    window.addEventListener('wheel', onOutsideScroll, { passive: true });
    window.addEventListener('touchmove', onOutsideScroll, { passive: true });
  })();

  function refreshDrawer() {
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (html) {
          var target = document.querySelector('#cartDrawer');
          if (target) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('#cartDrawer');
            if (fresh) {
              target.innerHTML = fresh.innerHTML;
              if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
            }
          }
        }
        openDrawer();
      })
      .catch(openDrawer);
  }

  /* ---------- Add to cart ---------- */
  function addToCart() {
    if (!current) return;
    var variantId = current.dataset.variantId;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (data) {
            var msg = (data && data.description) || 'Something went wrong. Please try again.';
            if (msg.toLowerCase().indexOf('maximum quantity') !== -1) msg = 'This item is already in your cart.';
            ping(msg);
            setCtaLabel();
          });
        }
        return r.json().then(function (item) {
          addBtn.classList.add('is-added');
          addBtn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg> Added to cart';
          // No toast on success: the side cart opens instead.
          updateCartCount();
          refreshDrawer();
          setTimeout(function () {
            addBtn.classList.remove('is-added');
            setCtaLabel();
          }, 2200);
        });
      })
      .catch(function () {
        ping('Something went wrong. Please try again.');
        setCtaLabel();
      });
  }

  if (addBtn) addBtn.addEventListener('click', addToCart);

  /* ---------- Init ---------- */
  var initial = null;
  for (var i = 0; i < packBtns.length; i++) {
    if (packBtns[i].classList.contains('is-selected')) { initial = packBtns[i]; break; }
  }
  if (!initial) {
    for (var j = 0; j < packBtns.length; j++) {
      if (!packBtns[j].disabled) { initial = packBtns[j]; break; }
    }
  }
  if (initial) selectPack(initial.dataset.variantId, { silent: true });
  var mediaEl = document.getElementById('hk-media');
  if (mediaEl) requestAnimationFrame(function () { mediaEl.classList.add('is-ready'); });
  updateCartCount();

  /* ---------- Wear it with: auto recommendations when no products picked ---------- */
  function esc(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function sized(src) {
    return src ? src.replace(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i, '_600x600.$1$2') : '';
  }
  function money(v) {
    return Number(v).toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
  function imgSrc(i) { return !i ? '' : (typeof i === 'string' ? i : (i.src || i.url || '')); }

  function renderWear(products, grid) {
    grid.innerHTML = products.map(function (p) {
      var imgs = p.images || [];
      var a = sized(imgSrc(imgs[0])), b = sized(imgSrc(imgs[1]));
      var price = typeof p.price_min === 'number' ? p.price_min / 100 : parseFloat((p.variants && p.variants[0] && p.variants[0].price) || 0);
      var cmp = typeof p.compare_at_price_min === 'number' ? p.compare_at_price_min / 100 : parseFloat((p.variants && p.variants[0] && p.variants[0].compare_at_price) || 0);
      var priceHtml = cmp > price
        ? '<span class="hk-card__sale">' + money(price) + '</span> <s>' + money(cmp) + '</s>'
        : money(price);
      return '<a class="hk-card" href="/products/' + p.handle + '"><div class="hk-card__img">' +
        (a ? '<img class="hk-card__primary" src="' + a + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') +
        (b ? '<img class="hk-card__secondary" src="' + b + '" alt="" loading="lazy" width="600" height="600">' : '') +
        '</div><div class="hk-card__name">' + esc(p.title) + '</div><div class="hk-card__price">' + priceHtml + '</div></a>';
    }).join('');
  }

  function hideWear() {
    var sec = document.getElementById('hk-wear');
    if (sec) sec.style.display = 'none';
  }

  function initWear() {
    var grid = document.getElementById('hk-wear-grid');
    if (!grid) return;
    if (grid.dataset.auto !== 'true') return;
    var pid = grid.dataset.productId;
    function others(d) {
      return (d && d.products ? d.products : []).filter(function (p) { return String(p.id) !== String(pid); });
    }
    function tryUrl(url) {
      return fetch(url).then(function (r) { return r.json(); }).then(others).catch(function () { return []; });
    }
    var h = grid.dataset.collectionHandle;
    var steps = ['/recommendations/products.json?product_id=' + pid + '&limit=4&intent=related'];
    if (h && h !== 'all') steps.push('/collections/' + h + '/products.json?limit=20');
    steps.push('/collections/all/products.json?limit=20');

    (function next(i) {
      if (i >= steps.length) return hideWear();
      tryUrl(steps[i]).then(function (list) {
        if (list.length) renderWear(list.slice(0, 4), grid);
        else next(i + 1);
      });
    })(0);
  }

  initWear();
})();